import React from 'react';

const SvgLink2 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M14.166 5.83203H10.8327V7.4987H14.166C15.541 7.4987 16.666 8.6237 16.666 9.9987C16.666 11.3737 15.541 12.4987 14.166 12.4987H10.8327V14.1654H14.166C16.466 14.1654 18.3327 12.2987 18.3327 9.9987C18.3327 7.6987 16.466 5.83203 14.166 5.83203ZM9.16602 12.4987H5.83268C4.45768 12.4987 3.33268 11.3737 3.33268 9.9987C3.33268 8.6237 4.45768 7.4987 5.83268 7.4987H9.16602V5.83203H5.83268C3.53268 5.83203 1.66602 7.6987 1.66602 9.9987C1.66602 12.2987 3.53268 14.1654 5.83268 14.1654H9.16602V12.4987ZM6.66602 9.16536H13.3327V10.832H6.66602V9.16536Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgLink2;
